// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.radio[data-v-747a81b4]{font-size:16px}.custom-permissions[data-v-747a81b4]{display:grid;grid-template-columns:1fr 1fr 1fr}", ""]);
// Exports
module.exports = exports;
